module.exports = __webpack_public_path__ + "assets/img/modal-avatar-e44c0906.png";